import { useStoreType } from '@hooks';
import { useMutation, useQueryClient } from 'react-query';

import { ApiError, HttpClient } from '../../_http';
import { useCustomerContext } from '../../shoppingCart/_context/CustomerContext';
import { TDigitalAddress, TDigitalAddressPayload } from '../_models/address';

function updateB2CDigitalShippingAddress(address: TDigitalAddress, userId: string): Promise<void> {
  const { id: addressId, ...body } = address;
  return HttpClient.put(
    `customers/${userId}/digital-shipping-addresses/${addressId}`,

    body as TDigitalAddressPayload,
  );
}

function updateB2BDigitalShippingAddress(address: TDigitalAddress, contactPersonId: string): Promise<void> {
  const { id: addressId, ...body } = address;
  return HttpClient.put(
    `b2b/companies/${contactPersonId}/contact-person/digital-shipping-address/${addressId}`,

    body as TDigitalAddressPayload,
  );
}

export function useUpdateDigitalShippingAddress() {
  const queryClient = useQueryClient();
  const { isB2C } = useStoreType();
  const { customer: { id: userId } = {} } = useCustomerContext();

  return useMutation<void, ApiError, TDigitalAddress>(
    'updateDigitalShippingAddress',
    body => (isB2C ? updateB2CDigitalShippingAddress(body, userId) : updateB2BDigitalShippingAddress(body, userId)),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('customer');
      },
    },
  );
}
